module.exports = __webpack_public_path__ + "static/media/Profit.d78651d8.svg";